'use strict';

var _classCallCheck = require("/Users/minjaelee/Documents/ERC-20/code/metagram/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/minjaelee/Documents/ERC-20/code/metagram/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/minjaelee/Documents/ERC-20/code/metagram/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/minjaelee/Documents/ERC-20/code/metagram/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/minjaelee/Documents/ERC-20/code/metagram/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var TransformStream = require('readable-stream').Transform;
/*
  Transforms a stream of {Name, Hash} objects to include size
  of the DAG object.

  Usage: inputStream.pipe(new FileResultStreamConverter())

  Input object format:
  {
    Name: '/path/to/file/foo.txt',
    Hash: 'Qma4hjFTnCasJ8PVp3mZbZK5g2vGDT4LByLJ7m8ciyRFZP'
    Size: '20'
  }

  Output object format:
  {
    path: '/path/to/file/foo.txt',
    hash: 'Qma4hjFTnCasJ8PVp3mZbZK5g2vGDT4LByLJ7m8ciyRFZP',
    size: 20
  }
*/


var FileResultStreamConverter =
/*#__PURE__*/
function (_TransformStream) {
  _inherits(FileResultStreamConverter, _TransformStream);

  function FileResultStreamConverter(options) {
    _classCallCheck(this, FileResultStreamConverter);

    var opts = Object.assign({}, options || {}, {
      objectMode: true
    });
    return _possibleConstructorReturn(this, _getPrototypeOf(FileResultStreamConverter).call(this, opts));
  }

  _createClass(FileResultStreamConverter, [{
    key: "_transform",
    value: function _transform(obj, enc, callback) {
      if (!obj.Hash) {
        return callback();
      }

      callback(null, {
        path: obj.Name,
        hash: obj.Hash,
        size: parseInt(obj.Size, 10)
      });
    }
  }]);

  return FileResultStreamConverter;
}(TransformStream);

module.exports = FileResultStreamConverter;